import { render, staticRenderFns } from "./PostGate.vue?vue&type=template&id=3e8a4958"
import script from "./PostGate.vue?vue&type=script&lang=js"
export * from "./PostGate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports